var listingPaginatedListFilters = $('.listing-paginated-list-filters');

if (listingPaginatedListFilters.length >0) {
  var filterControl = listingPaginatedListFilters.find('.filters-control');

  if (filterControl.hasClass('active')) {
    filterControl.html("Hide Filters");
    listingPaginatedListFilters.find('form').show();
  }
  else {
    filterControl.html("Show Filters");
    listingPaginatedListFilters.find('form').hide();
  }

  filterControl.on('click', function() {
    if ($(this).hasClass('active')) {
      $(this).html("Show Filters");
      listingPaginatedListFilters.find('form').hide();      
    } 
    else {
      $(this).html("Hide Filters");
      listingPaginatedListFilters.find('form').show();
    }
    $(this).toggleClass('active');
  });

  $(window).on('load resize orientationchange', function () {
    var maxHeight = null;
    $('.filters-item label').each(function () {
      maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
    });
    var loop_counter = 0;
    $('.filters-item label').each(function () {
      if (window.innerWidth <= 1300) {
        $(this).height(maxHeight);
        if ((loop_counter >= 2) && (window.innerWidth <= 767 )) {
          $(this).height("initial");
        }
      } else {
        $(this).height("initial");
      }
      loop_counter++;
    });
  });
}